import MatchEvent from 'interfaces/matchEvent';
import { MatchEventType } from '../enums/matchEventType';

function eventAlreadyExists(matchEvents: MatchEvent[], id: MatchEventType, liveFeedSerialId?: number): boolean {
  // This needs to be here because a user may try to update the event before the post has completed.
  if (liveFeedSerialId) {
    return !!matchEvents.find((matchEvent) => matchEvent.liveFeedSerialId === liveFeedSerialId);
  }

  return !!matchEvents.find((matchEvent) => matchEvent.matchEventTypeId === id);
}

export default eventAlreadyExists;
